module.exports = __webpack_public_path__ + "static/media/home16.cc5f55db.jpg";